import { InventoryExportService } from './inventory-export.service';
import { saveAs } from 'file-saver';
import {AuctionService, LaunchDarklyService, DateUtilsService} from 'remarketing-angular-library';
import { Store } from '@ngxs/store';

/**
 * This is provided as a factory because the `file-saver` dependency needs to be injected.
 */
export function inventoryExportServiceFactory(
  auctionService: AuctionService,
  store: Store,
  launchDarklyService: LaunchDarklyService,
  dateUtilsService: DateUtilsService
  ): InventoryExportService {
  return new InventoryExportService(saveAs, auctionService, store, launchDarklyService, dateUtilsService);
}

export const InventoryExportServiceProvider = {
  provide: InventoryExportService,
  useFactory: inventoryExportServiceFactory,
  deps: [AuctionService, Store, LaunchDarklyService, DateUtilsService]
};
